import { Box, ColorOptions, IconNew, Text, useWindowDimensions } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import { View } from 'react-native'
import { shadowStyle } from '../../util/util'

export const SplitRefundModal = ({ data, rowData, rootView }: any) => {
  const parentViewRef = useRef(null)
  const [hoverViewVisible, setHoverViewVisible] = useState(false)
  const pos = useRef({ left: undefined, top: undefined })

  const screenW = useWindowDimensions()
  const renderView = () => {
    if (!hoverViewVisible) {
      return null
    }
    const getTop = () => {
      const topPos = pos.current?.top ?? 0
      return topPos + 32
    }
    const getLeft = () => {
      const leftPos = pos.current?.left ?? 0
      if (!isEmpty(rootView)) {
        const left = leftPos - (screenW - 650)
        return left
      }
      return leftPos - 8
    }
    return (
      <Box
        bg={'TRANSPARENT'}
        w={'100%'}
        h={'100%'}
        position={'absolute'}
        top={0}
        left={0}
        underlayColor={'TRANSPARENT'}
        testID="split-view"
        onPress={() => setHoverViewVisible(false)}>
        <Box
          {...shadowStyle}
          bg={'WHITE'}
          left={getLeft()}
          top={getTop()}
          minWidth={115}
          maxWidth={156}
          h={data?.length * 35}
          onPress={() => null}
          zIndex={10000000}
          borderRadius={4}>
          <Box flex={1} justifyContent="center">
            {data?.map((item) => (
              <Box
                ph={14}
                pv={5}
                h={35}
                flexDirection={'row'}
                gap={8}
                align={'center'}
                testID={'split-item-' + item.value}
                onPress={() => [setHoverViewVisible(false), item.onPress(rowData)]}
                underlayColor={'TRANSPARENT'}>
                <View style={{ transform: [{ rotate: item.transformAngle }] }}>
                  <IconNew id={item.icon as any} color={item.color as ColorOptions} size={16} />
                </View>
                <Text title={item.value} fontSize={11} fontFamily={'jiotype-medium'} />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    )
  }
  const renderModal = () => {
    return ReactDOM.createPortal(renderView(), rootView ?? document.body)
  }

  const onPress = () => {
    parentViewRef.current?.measure((_fx, _fy, _width, _height, px, py) => {
      pos.current = { left: px, top: py }
      setHoverViewVisible(!hoverViewVisible)
    })
  }

  if (data?.length === 0) {
    return null
  }
  return (
    <Box ref={parentViewRef} testID="split-modal" onPress={() => onPress()} underlayColor={'TRANSPARENT'}>
      {hoverViewVisible && renderModal()}
      <IconNew id={'OPTIONS'} />
    </Box>
  )
}
